import produce from 'immer';
import { create } from 'zustand';

const useUserCausesStore = create((set) => ({
  showEditor: false,
  causes: [],
  setShowEditor: (show, causes = []) =>
    set(
      produce((draft) => {
        draft.showEditor = show;
        draft.causes = causes;
      }),
    ),
}));

export default useUserCausesStore;
